import React from "react";
import { cn } from "@/lib/utils";

export type FusionBodyProps = React.PropsWithChildren & {
    className?: string;
};

export const FusionBody = ({ children, className }: FusionBodyProps): JSX.Element => {
    return (
        <div className={cn("preflight bg-sidebar h-screen font-sans", className)}>{children}</div>
    );
};
